<template>
    <div class="holiday-container">
        <div class="holiday-header">
            <span class="holiday-add">Holidays</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addHolidayItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new holiday</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="holidaysData" :owner="'holiday'" :saving="saving" :returnMaskedValue="returnMaskedValue"
                @deleteItem="deleteHolidayItem" @saveItem="saveHoliday" @cancelEdit="cancelEditHolidayItem" :validateDate=true
                @editItem="editHolidayItem" class="holiday-table" :mask="'####-##-##'" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'holiday-list',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false,
                returnMaskedValue: true
            };
        },
        computed: {
            ...mapGetters({ holidays: 'getHolidays' }),
            holidaysData() {
                return {
                    items: [
                        ...this.holidays
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteHoliday',
                'addHoliday',
                'editHoliday',
                'cancelHolidayEdit',
                'changeHoliday',
                'createNewHoliday'
            ]),
            deleteHolidayItem(index) {
                this.deleteHoliday(index);
            },
            addHolidayItem() {
                this.addHoliday({
                    id: -1,
                    date: '',
                    editting: true,
                    editable: true
                });
            },
            editHolidayItem(holidayId) {
                this.editHoliday(holidayId);
            },
            cancelEditHolidayItem() {
                this.cancelHolidayEdit();
            },
            saveHoliday(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeHoliday(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewHoliday(moment(payload.name, 'YYYY-MM-DD')).then(() => {
                        this.saving = false;
                    }, err => { this.saving = false; });
                }
            }
        }
    };
</script>
<style scoped>
.holiday-container {
    padding-bottom: 26px;
}

.holiday-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.holiday-table {
    margin: 0 26px;
}

.holiday-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .holiday-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .holiday-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/HolidayList.vue